module.exports = __webpack_public_path__ + "img/room6.c5ad4052.jpeg";